import React from 'react'
import "./contact.css"

const contact = () => {
  return (
    <div id='contact' className='mb-4'>
            <h3 className='text-3xl py-1 text-#1281A4'>Get in Touch</h3>
            <a href="mailto:etim.utibe@gmail.com" className='cursor-pointer'  target="_blank">etim.utibe@gmail.com</a>
    </div>
  )
}

export default contact
